import React from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import company from '../config/company';
import usePageMeta from '../seo/usePageMeta';
import './Datenschutz.css';

const Impressum = () => {
  usePageMeta({
    title: 'Impressum | Cura Care GmbH',
    description: `Impressum der ${company.legalName}, ${company.street}, ${company.zip} ${company.city}.`,
    path: '/impressum'
  });

  const hasRegister = Boolean(company.register.court && company.register.number);

  return (
    <div className="page-view">
      <Header />

      <div className="legal-page">
        <main className="legal-card">
          <h1 className="legal-title">Impressum</h1>

          <section className="legal-section">
            <h2>Angaben gemäß § 5 DDG</h2>
            <p>
              <strong>{company.legalName}</strong><br />
              {company.street}<br />
              {company.zip} {company.city}
            </p>
            <p>
              Telefon: <a href={`tel:${company.phoneIntl}`}>{company.phone}</a><br />
              E-Mail: <a href={`mailto:${company.email}`}>{company.email}</a>
            </p>
            <p>
              Vertreten durch die Geschäftsführung: <strong>{company.managingDirector}</strong>
            </p>
            {/* TODO (Cura Care): Registergericht, Handelsregisternummer und USt-IdNr. in
                src/config/company.js eintragen. Für eine GmbH sind diese Angaben Pflicht. */}
            {hasRegister ? (
              <p>
                Registergericht: {company.register.court}<br />
                Registernummer: {company.register.number}
              </p>
            ) : null}
            {company.vatId ? (
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: {company.vatId}</p>
            ) : null}
          </section>

          <section className="legal-section">
            <h2>Zuständige Aufsichtsbehörde</h2>
            <p>
              {company.supervisoryAuthority.name}<br />
              {company.supervisoryAuthority.street}<br />
              {company.supervisoryAuthority.city}<br />
              <a href={company.supervisoryAuthority.url} target="_blank" rel="noreferrer">
                Website der Heimaufsicht
              </a>
            </p>
          </section>

          <section className="legal-section">
            <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
              {company.managingDirector}<br />
              {company.street}, {company.zip} {company.city}
            </p>
          </section>

          <section className="legal-section">
            <h2>Rechtliche Hinweise</h2>
            <h3>Urheberrecht und Gestaltung</h3>
            <p>
              Alle Inhalte und die Gestaltung dieser Website sind urheberrechtlich geschützt.
              Sofern nicht anders angegeben, liegen alle Rechte bei der{' '}
              <strong>{company.legalName}</strong>.
            </p>
            <p>
              Die auf der Kontaktseite optional ladbare Karte basiert auf Google Maps und
              unterliegt den Nutzungsbedingungen von Google.
            </p>
          </section>

          <section className="legal-section">
            <h2>1. Haftungsbeschränkung</h2>
            <p>
              Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. {company.brandName} übernimmt jedoch
              keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte. Die
              Nutzung der Inhalte der Website erfolgt auf eigene Gefahr der Nutzerin oder des Nutzers.
            </p>
            <p>
              Namentlich gekennzeichnete Beiträge geben die Meinung der jeweiligen Autorin oder des jeweiligen Autors
              und nicht immer die Meinung von {company.brandName} wieder. Allein durch den Besuch dieser Website kommt kein
              Vertragsverhältnis zwischen Nutzer:innen und {company.brandName} zustande.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Externe Links</h2>
            <p>
              Diese Website kann Verknüpfungen zu Websites Dritter („externe Links“) enthalten. Diese Websites
              unterliegen der Haftung der jeweiligen Betreiber:innen. {company.brandName} hat bei der erstmaligen Verknüpfung der
              externen Links die fremden Inhalte daraufhin überprüft, ob etwaige Rechtsverstöße bestehen; zu diesem
              Zeitpunkt waren keine Rechtsverstöße ersichtlich.
            </p>
            <p>
              {company.brandName} hat keinen Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der
              verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich {company.brandName} die hinter dem
              Verweis oder Link liegenden Inhalte zu eigen macht. Eine ständige Kontrolle dieser externen Links ist
              ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden
              derartige externe Links unverzüglich gelöscht.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Urheber- und Leistungsschutzrechte</h2>
            <p>
              Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und
              Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung
              bedarf der vorherigen schriftlichen Zustimmung von {company.brandName} oder der jeweiligen Rechteinhaber:innen.
            </p>
            <p>
              Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw.
              Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte
              Dritter sind als solche gekennzeichnet.
            </p>
            <p>
              Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht
              gestattet und kann strafbar sein. Lediglich die Herstellung von Kopien und Downloads für den
              persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt.
            </p>
            <p>
              Die Darstellung dieser Website in fremden Frames ist nur mit vorheriger schriftlicher Erlaubnis von
              {' '}{company.brandName} zulässig.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Besondere Nutzungsbedingungen</h2>
            <p>
              Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Nummern 1 bis 3
              abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem Fall gelten im
              jeweiligen Einzelfall die besonderen Nutzungsbedingungen.
            </p>
            <p className="legal-source">Quelle: www.juraforum.de</p>
          </section>

          <section className="legal-section">
            <h2>5. Verbraucherstreitbeilegung</h2>
            <p>
              Wir sind nicht verpflichtet, an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen und können die Teilnahme an einem solchen Verfahren derzeit
              leider auch nicht anbieten.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Datenschutz</h2>
            <p>
              Unsere ausführliche Datenschutzerklärung finden Sie hier:{' '}
              <Link to="/datenschutz">Zur Datenschutzerklärung</Link>.
            </p>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Impressum;
